<template>
  <div>
    <pageHeader :headerIcon="'syringe'"
                :headerText="'Invoices'"
                :haveFilterInput="false">
    </pageHeader>

    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>

    <div style="padding-top: 25px;" v-else>
      <abstractTable :columns="invoicesColumns" :data="computedInvoices"
                     :classes="'ui tablet very compact center aligned celled table'"
                     :dataPerPage="10" :paginationEnable="true"
                     :paginationNextButtonText="$t('next')"
                     :paginationFirstPageButtonText="$t('first')"
                     :paginationLastPageButtonText="$t('last')"
                     :paginationPervButtonText="$t('previous')" v-if="computedInvoices.length">

        <template slot="table-column">
          <th> {{ $t('actions') }} </th>
        </template>

        <template slot="table-row-after" slot-scope="props">
          <td style="width: 78px">
            <div class="ui blue very compact mini button" style="background-color: #092442"
                  @click="props.row.id.functionality()">
              {{ $t('show') }}
            </div>
          </td>
        </template>
      </abstractTable>

      <div v-else class="ui placeholder segment" style="margin-top: 30px; width: 100%">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No invoices have been made.
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="navigateTo('New_Purchased_Invoice')">
          Make invoice
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      invoices: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('invoices', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.invoices = response.data
      this.loading = false
    })
  },
  computed: {
    invoicesColumns () {
      return [
        { header: 'Invocie Id', fieldName: 'id', show: true, html: true },
        { header: 'Real Invoice Number', fieldName: 'realNumber', show: true },
        { header: 'System Invoice Number', fieldName: 'systemNumber', show: true },
        { header: 'Recipient Name', fieldName: 'recipient', show: true },
        { header: 'Invoice Type', fieldName: 'invoiceType', show: true },
        // { header: 'Company', fieldName: 'companyName', show: true },
        { header: 'Purchased Date', fieldName: 'date', show: true }
      ]
    },
    computedInvoices () {
      let formlatedInvoices = []

      window._.each(this.invoices, invoice => {
        formlatedInvoices.push({
          id: {
            functionality: () => {
              this.navigateTo('Show_Invoice', { key: 'params', value: { id: invoice.id } })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${invoice.id}</a>`
          },
          recipient: invoice.recipient.name,
          realNumber: invoice.real_number || '-',
          systemNumber: this.displaySystemCode(invoice.system_number),
          date: window.moment(invoice.date).format('DD/MM/YYYY hh:mm a'),
          // companyName: invoice.branch.company.name,
          invoiceType: invoice.invoice_type.name
        })
      })

      return formlatedInvoices
    }
  },
  methods: {
    displaySystemCode (code) {
      if (code.length < 8) {
        return '0'.repeat(8 - code.length) + code
      }

      return code
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/inventory_system/invoices/Invoices.vue